export const HEADER_INITIAL_WIDTH = '100%';
export const HEADER_MAX_WIDTH = '800px';
export const HEADER_HEIGHT = 64;
